import React, { useState } from 'react'
import { Card, CardBody, Button } from 'reactstrap'
import { Textbox } from "react-inputs-validation";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ComponentPersonas = ({ personas, mostrarErrores, setPersonas, cerrado, plan }) => {



    const generarBotonesDetalles = (index) => {

        const [showModal, setShowModal] = useState(false);

        const toggleModal = () => {
          setShowModal(!showModal);
        };
      
        const handleDelete = () => {
          const clonedData = [...personas];
          clonedData.splice(index, 1);
          setPersonas(clonedData);
          toggleModal();
        };
      
        return (
          <div>
            <Button
              className={"button-white"}
              style={{ marginRight: "0.2em" }}
              onClick={toggleModal}
            >
              <i className="fa fa-trash-alt" aria-hidden="true" /> ELIMINAR
            </Button>
      
            <Modal isOpen={showModal} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>
                Confirmar eliminación
              </ModalHeader>
              <ModalBody>
                ¿Estás seguro de que deseas eliminar este registro?
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={toggleModal}>
                  Cancelar
                </Button>
                <Button color="danger" onClick={handleDelete}>
                  Eliminar
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        );
      
    };



    return (
        <Card>
            <CardBody>
                <h4>Lista de personas por subir ({personas.length}) {`${plan? `- ${plan}` :''}`} </h4>
                <br></br>

                {personas.length > 0 ?
                    <table className='table' >
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nro. Identificación</th>
                                <th>Nombres</th>
                                <th>Fecha Nacimiento</th>

                                {cerrado &&
                                    <th>Cargo</th>
                                }
                                {mostrarErrores &&
                                    <th>Mensaje</th>
                                }


                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {personas.map((persona, index) => {

                                console.log('persona2222', persona)

                                var dateParts = null
                                if(persona.fechaNacimiento){

                                     dateParts = persona.fechaNacimiento.split("/");

                                }else if(persona["FECHA DE NACIMIENTO"]){
                                    var dateParts = persona["FECHA DE NACIMIENTO"].split("/");
                                }

                        
                                var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                                return (
                                    <tr key={"table" + index}>
                                        <th>{index + 1}</th>
                                        <td>
                                            <Textbox
                                                tabIndex="1"
                                                type={'text'}
                                                value={persona.IDENTIFICACION ? persona.IDENTIFICACION : persona.identificacion}
                                                name={'identificacion' + index}
                                                id={index}
                                                classNameInput={"form-control"}
                                                placeholder={'Identificación'}
                                                onChange={(valor, e) => {

                                                    const clonedData = [...personas];

                                                    clonedData[index].IDENTIFICACION = valor;

                                                    setPersonas(clonedData);
                                                }}

                                                //disabled={true}
                                                validate={false}
                                                validationCallback={res => {
                                                    // validationCallback(res)

                                                }} // Optional.[Func].Default: none. Return the validation result.
                                                validationOption={{
                                                    type: 'string',
                                                    required: true,
                                                    maxlength: 25,
                                                    min: 1,
                                                    //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                                                    // reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                                                    msgOnError:
                                                        'Ingrese un número válido'
                                                }}

                                            />

                                        </td>
                                        <td>
                                            <Textbox
                                                tabIndex="1"
                                                type={'text'}
                                                value={persona['NOMBRE Y APELLIDO'] ? persona['NOMBRE Y APELLIDO'] : persona.nombre}
                                                name={'nombre' + index}
                                                id={index}
                                                classNameInput={"form-control"}
                                                placeholder={'Nombre'}
                                                onChange={(valor, e) => {
                                                    const clonedData = [...personas];

                                                    clonedData[index]['NOMBRE Y APELLIDO'] = valor;

                                                    setPersonas(clonedData);
                                                }}

                                                //disabled={true}
                                                validate={false}
                                                validationCallback={res => {
                                                    // validationCallback(res)

                                                }} // Optional.[Func].Default: none. Return the validation result.
                                                validationOption={{
                                                    type: 'string',
                                                    required: true,
                                                    maxlength: 100,
                                                    min: 1,
                                                    //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                                                    // reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                                                    msgOnError:
                                                        'Ingrese un nombre válido'
                                                }}

                                            />
                                        </td>
                                        <td>

                                            <DatePicker

                                                dateFormat="dd/MM/yyyy"
                                                isClearable={false}
                                                selected={dateObject}
                                                onChange={(valor) => {
                                                    const clonedData = [...personas];



                                                    clonedData[index].fechaNacimiento = moment(valor).format("DD/MM/YYYY")



                                                    console.log('asd', moment(dateObject).format("DD/MM/YYYY"))

                                                    setPersonas(clonedData);
                                                }}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                className="form-control"

                                            />
                                        </td>

                                        {cerrado &&
                                            <td>
                                                <Textbox
                                                    tabIndex="1"
                                                    type={'text'}
                                                    value={persona['CARGO'] ? persona['CARGO'] : persona.cargo}
                                                    name={'cargo' + index}
                                                    id={index}
                                                    classNameInput={"form-control"}
                                                    placeholder={'Cargo'}
                                                    onChange={(valor, e) => {
                                                        const clonedData = [...personas];

                                                        clonedData[index]['CARGO'] = valor;

                                                        setPersonas(clonedData);
                                                    }}

                                                    //disabled={true}
                                                    validate={false}
                                                    validationCallback={res => {
                                                        // validationCallback(res)

                                                    }} // Optional.[Func].Default: none. Return the validation result.
                                                    validationOption={{
                                                        type: 'string',
                                                        required: true,
                                                        maxlength: 100,
                                                        min: 1,
                                                        //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                                                        // reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                                                        msgOnError:
                                                            'Ingrese un cargo válido'
                                                    }}

                                                />
                                            </td>
                                        }
                                        {mostrarErrores &&
                                            <td>
                                                <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{persona.mensaje}</div>



                                            </td>
                                        }

                                        <td>

                                            {generarBotonesDetalles(index)}
                                        </td>
                                    </tr>

                                )
                            })}

                        </tbody>
                    </table> :
                    <div style={{ textAlign: 'center' }}>
                        <h5>No hay elementos</h5>
                    </div>
                }


            </CardBody>
        </Card>
    )

}

export default ComponentPersonas